module.exports = __webpack_public_path__ + "img/carbon_qr-code.5f4e9fa3.svg";